/**
 * Used in parent window to listen and process incoming messages from child window(s)
 */
function MessengerServer(namespace) {
    this.namespace = namespace || 'Accent';
    this.childWindows = [];
    this.listeners = [];

    window.addEventListener('message', this.windowListener.bind(this));
}

MessengerServer.prototype.windowListener = function(event) {
    var message = event.data;
    if (message.namespace !== this.namespace) {
        return;
    }

    switch (message.type) {
        case 'REGISTER':
            var childWindow = event.source;
            this.registerChild(childWindow);
            break;
        case 'DISPATCH':
            this.processDispatchMessage(message.payload);
            break;
    }
}

MessengerServer.prototype.registerChild = function(childWindow) {
    this.childWindows.push(childWindow);

    this.sendMessageToChild(childWindow, 'REGISTERED');
}

// Broadcast a message to all child windows
MessengerServer.prototype.broadcast = function(payload) {
    this.sendMessageToChildren('BROADCAST', payload);
}

MessengerServer.prototype.sendMessageToChildren = function(type, payload) {
    var self = this;

    this.childWindows.forEach(function(childWindow) {
        self.sendMessageToChild(childWindow, type, payload);
    });
}

MessengerServer.prototype.sendMessageToChild = function(childWindow, type, payload) {
    var message = {
        namespace: this.namespace,
        type: type,
        payload: payload
    };

    childWindow.postMessage(message, '*');
}

MessengerServer.prototype.addListener = function(listener) {
    this.listeners.push(listener);
};

MessengerServer.prototype.processDispatchMessage = function(payload) {
    this.listeners.forEach(function(listener) {
        listener(payload);
    });
}


/**
 * Used in child window to send messages to parent window
 */
function MessengerClient(namespace) {
    this.namespace = namespace || 'Accent';
    this.isRegistered = false;
    this.listeners = [];

    this.registerWithParent();

    window.addEventListener('message', this.windowListener.bind(this));
}

MessengerClient.prototype.windowListener = function(event) {
    var message = event.data;
    if (message.namespace !== this.namespace) {
        return;
    }

    switch (message.type) {
        case 'REGISTERED':
            this.isRegistered = true;
            break;
        case 'BROADCAST':
            this.processBroadcastMessage(message.payload);
            break;
        case 'DISPATCH':
            this.processDispatchMessage(message.payload);
            break;
    }
};

MessengerClient.prototype.registerWithParent = function() {
    var mobileHandler = this.getMobileHandler();
    if (mobileHandler) {
        // We are inside mobile app, so don't try to register with parent iframe
        this.isRegistered = true;
        return;
    }

    this.sendMessageToParent('REGISTER');
}

// Dispatch a message to the parent window 
MessengerClient.prototype.dispatch = function(payload) {
    this.sendMessageToParent('DISPATCH', payload);
}

MessengerClient.prototype.sendMessageToParent = function(type, payload) {
    var message = {
        namespace: this.namespace,
        type: type,
        payload: payload
    };

    var mobileHandler = this.getMobileHandler();
    if (mobileHandler) {
        mobileHandler.postMessage(JSON.stringify(message));
    }
    else if (window.parent !== window) {
        window.parent.postMessage(message, '*');
    }
}

MessengerClient.prototype.getMobileHandler = function() {
    if (window.webkit && window.webkit.messageHandlers["iosHandler"]) {
        return window.webkit.messageHandlers["iosHandler"];
    }

    if (window["androidHandler"]) {
        return window["androidHandler"];
    }

    return null;
}

MessengerClient.prototype.processBroadcastMessage = function(payload) {
    console.error("Listeners have not been implemented for BROADCAST messages. Payload = ", payload);
}

MessengerClient.prototype.processDispatchMessage = function(payload) {
    this.listeners.forEach(function(listener) {
        listener(payload);
    });
}

MessengerClient.prototype.addListener = function(listener) {
    this.listeners.push(listener);
};